/* 全局参数 */
import { setStorage, getStorage, isWeiXin } from '@/libs/utils'
import _ from 'lodash';
import moment from 'moment';

import {
  payType as getPayTypeList,
  getInnerProductId,
  queryOrderResult,
  placeOrder,
  uploadTQLog,
  yybInnerPayRes,
  placeLargeOrder,
  getWxQrCode,
  cloudOrderPreCreate,
  commonPayOrder,
  miniLeadPayConfig,
  miniLeadPayGift,
  cXqueryOrder,
  getTiktokSign
} from '@/api/pay';
import {
  thirdSDKSwitch,
  registShowFloatFunction,
  registWithinFunction,
  registReturnGameFunction,
  registFunFailFunction,
  registFunSuccessReportFunction,
  registSmallProgramFunction,
  registInnerPurchaseFunction,
  getOrdersInfo,
  registSetWindowAlpha,
  reportUserTopUp,
  openFloatBall,
  tiktokPay
} from '@/bridge/AppJsBridge';
import { handleThirdLib } from '@/libs/business/account';
import { ENV_URL, payTypeListClassify } from '@/config';
import { isAndroid, isPure, deleteDivIfExists } from '@/libs/utils';
import { cpsPayOrder, cpsOrderCheck } from '@/libs/business/cpsReport'
import { mergeQrCode } from '@/libs/business/charge'
import QRCode from 'qrcode'
import { buryReportV2 } from '@/libs/business/account';
import { APPKEY_PARAMS } from '@/config/whiteList';

const state = {
  /* H5部分单独使用 */
  /* -------------------- */
  /*  原生单独使用   */
  /*  ----------------   */
  /*      通用部分    */
  antiIndulgedPayVisible: false, // 是否显示防沉迷弹窗
  qrCodeVisible: false, // 是否显示扫码支付二维码
  qrCodeLink: '',
  open: 0, // 三方支付打开状态，0关闭，1打开
  pay_type: '', // 支付类型
  img_class_name: '', // alipay wechat e_pay
  isQrCode: false,
  current_type: '', // 当前选择的支付类型
  chargeList: [], // pay-type接口获取的支付类型列表
  allChargeList: [],
  transferChargeList: [],
  hideWxPayType: false,
  thirdChargeVisible: false, // 是否显示支付窗口
  orderIframeLink: '', // 订单iframe链接
  orderShow: false, // 是否显示订单iframe
  order_sn: '', // 悦玩订单号
  order_info: {},
  yyb_info: {},
  thirdLibs: '', // 三方库
  largeChargeVisible: false, // 是否显示大额支付
  large_status: 0, // 当前用户是否支持大额支付
  large_info: {}, // 大额支付信息
  guideRemindVisible: false,
  guideRemindInfo: {},
  loopTimes: 0,
  guideBrowserVisible: false,
  cloudPayInfo: {}, // 云挂机业务预下单后支付相关信息，用于调用手游下单接口
  ali_gift: 0, // 是否存在转移包礼包码
  giftCodeVisible: false,
  transferGiftCode: '',
  payResult: false,
  reportOrder: {},
  cxTimes: 0,//彩消查询订单定时器,
  orderState: 0,//彩消订单状态
  innerProductIdList: {}, // 新增：内购商品ID列表
  /*  ----------------   */
};

const mutations = {
  CHANGE_STATE: (state, obj) => {
    state = Object.assign(state, obj);
  },
  showMorePayType: (state) => {
    state.hideWxPayType = false;
    state.chargeList = state.allChargeList;
  },
  SET_INNER_PRODUCT_ID_LIST(state, list) {
    state.innerProductIdList = list;
  }
};

const actions = {
  // 初始化TQLib SDK
  async initTQLib({ rootState, commit }) {
    return new Promise((resolve, reject) => {
      // 动态加载TQLib脚本
      const script = document.createElement('script');
      script.src = 'https://pubfront.tqhd123.cn/h5/tqlib.js';
      script.onload = () => {
        try {
          // 脚本加载完成后初始化
          // 这里使用 window.TQLIB 来避免 ESLint 错误
          const TQLIB = window.TQLIB;
          const tqlib = new TQLIB();
          const { appkey } = rootState.user;
          if (APPKEY_PARAMS[appkey]) {
            tqlib.init({ 
              tq_game_secret:  APPKEY_PARAMS[appkey].client_secret, 
              tq_app_id:  APPKEY_PARAMS[appkey].tq_app_id 
            }, function (res) {
              if (res.status === 1) {
                commit('CHANGE_STATE', { tqlib, isOpenTQPay: true });
                resolve(tqlib);
              } else {
                // 初始化失败，上报日志 uploadTQLog
                uploadTQLog({
                  msg: '天穹SDK初始化失败',
                  tqres: res,
                  errorMsg: res.message,
                  appkey,
                  user_id: getStorage('user_id') || ''
                }).catch((error) => {
                  console.error('天穹SDK初始化失败日志上报失败', error);
                });
                reject(new Error(res.message));
              }
            });
          }
        } catch (error) {
          reject(error);
        }
      };
      script.onerror = () => reject(new Error('Failed to load TQLib'));
      document.head.appendChild(script);
    });
  },
  // 确保TQLib已初始化的辅助方法
  async ensureTQLibInitialized({ state, dispatch }) {
    if (!state.tqlib) {
      try {
        await dispatch('initTQLib');
        return true;
      } catch (error) {
        return false;
      }
    }
    return true;
  },
  // ios初始化时候调用一次获取支付方式方法，通知客户端是内购还是三方支付(不通知ios端不会显示悬浮球)
  async judgePayType({ state, rootState }) {
    const { appkey, game_version, channel, device_info, third_sdk_status } = rootState.user;
    const user_id = (getStorage('user_id')) || '';
    const r = await getPayTypeList({
      jh_app_id: appkey,
      game_version: game_version,
      channel: channel,
      device_id: device_info.device_id,
      user_id: user_id,
      ysdk_day_status: third_sdk_status || false
    });
    const { open, thirdLibs, float } = r.content;

    
    if (!isAndroid()) {
      thirdSDKSwitch(thirdLibs);
      registWithinFunction(open);
    }
    registShowFloatFunction({ float: float });
  },
  // async getInnerProductId({ state, rootState, commit, dispatch }, orderInfo) {
  //   console.log('调用了==>  getInnerProductId');
  //   const {
  //     appkey,
  //     game_version,
  //     channel,
  //     device_info,
  //     third_sdk_status,
  //     user_id
  //   } = rootState.user;
  //   const r = await getInnerProductId({
  //     appkey: appkey
  //   });
  //   console.log('-----', r.content);
  // },
  async getPayTypeList({ state, rootState, commit, dispatch }, orderInfo) {
    const {
      appkey,
      game_version,
      channel,
      device_info,
      third_sdk_status,
      user_id
    } = rootState.user;
    const r = await getPayTypeList({
      jh_app_id: appkey,
      game_version: game_version,
      channel: channel,
      device_id: device_info.device_id,
      user_id: user_id,
      ysdk_day_status: third_sdk_status || false,
      wifiname: device_info.wifiname,
      money: orderInfo ? orderInfo.zfAmount : '',
      apple_product_id: orderInfo ? (orderInfo.apple_product_id || orderInfo.product_id || orderInfo.appleProductId) : ''
    });
    const { thirdLibs, open, info, large_status, large_info, qrcode_status, qrcode_info, lead_pop_status, lead_pop } = r.content;
    commit('CHANGE_STATE', { open, thirdLibs });
    registWithinFunction(open);
    if (!open) {
      const thirdPlatform = getStorage('android_third_platform');
      if (thirdPlatform) {
        const pay_type = payTypeListClassify.client[thirdPlatform];
        commit('CHANGE_STATE', { pay_type: pay_type });
      } else if (!isAndroid()) {
        if (lead_pop_status == 1) {
          registSetWindowAlpha(1)
          if (lead_pop.pop_status == 0) {
            commit('global/showCommonToast', '充值失败，请联系客服处理~', { root: true });
            setTimeout(() => {
              registReturnGameFunction(null);
            }, 3000);
            return;
          }
          commit('CHANGE_STATE', {
            guideRemindVisible: true,
            guideRemindInfo: lead_pop
          })
          return;
        } else {
          commit('CHANGE_STATE', { pay_type: payTypeListClassify.client['ios'] });
        }
      }
      if (orderInfo) dispatch('placeOrder');
    } else {
      let transferInfo = { hide_wechat: 0, ali_gift: 0 };
      try {
        const r = await miniLeadPayConfig({ appkey });
        transferInfo = r.content;
      } catch (error) {
      }
      commit('user/CHANGE_STATE', { chargeVisible: true }, { root: true });
      const allChargeList = mergeQrCode(info, qrcode_status, qrcode_info);

      // 根据配置判断是否屏蔽支付宝
      // const shouldHideAlipay = APPKEY_PARAMS[appkey]?.hide_alipay || false;
      // // 过滤支付方式列表
      // let filteredChargeList = allChargeList;
      // if (shouldHideAlipay) {
      //   // 屏蔽支付宝
      //   filteredChargeList = allChargeList.filter(item => item.img_class_name !== "alipay");
      // }

      const transferChargeList = allChargeList.filter(item => item.img_class_name != "wechat");
      commit('CHANGE_STATE', {
        thirdChargeVisible: true,
        chargeList: transferInfo.hide_wechat == 1 ? transferChargeList : allChargeList,
        allChargeList: allChargeList,
        transferChargeList: transferChargeList,
        hideWxPayType: transferInfo.hide_wechat == 1,
        ali_gift_image: transferInfo.ali_gift_image,
        ali_gift: transferInfo.ali_gift,
        large_status,
        large_info,
        qrcode_status,
        qrcode_info
      });
    }
  },
  async getTQPayTypeList({ state, rootState, commit, dispatch }, orderInfo) {
    await dispatch('initTQLib');
    const {
      appkey,
      game_version,
      channel,
      device_info,
      third_sdk_status,
      user_id
    } = rootState.user;

    // 使用默认值替代 API 请求
    const defaultContent = {
      open: 1,
      info: [
        {
          status: 1,
          pay_en: "AliPayV2",
          config: "",
          id: 43,
          recommend: 0,
          pay_type: 57,
          unite_name: "支付宝",
          discount: 0,
          discount_text: null,
          img_class_name: "alipay",
          pay_name: "支付宝官方v2"
        },
        {
          status: 1,
          pay_en: "WechatPay",
          config: "",
          id: 12,
          recommend: 0,
          pay_type: 26,
          unite_name: "微信",
          discount: 0,
          discount_text: null,
          img_class_name: "wechat",
          pay_name: "微信官方支付"
        }
      ],
      large_status: 0,
      large_info: [],
      qrcode_status: null,
      qrcode_info: [],
      lead_pop_status: 0,
      lead_pop: null,
      float: 0,
      thirdLibs: []
    };
    
    // 使用默认值构造完整响应对象
    const r = {
      ret: 1,
      msg: "操作成功",
      content: defaultContent
    };
    
    const { thirdLibs, open, info, large_status, large_info, qrcode_status, qrcode_info, lead_pop_status, lead_pop } = r.content;
    commit('CHANGE_STATE', { open, thirdLibs });
    registWithinFunction(open);
    
    let transferInfo = { hide_wechat: 0, ali_gift: 0 };
    try {
      const r = await miniLeadPayConfig({ appkey });
      transferInfo = r.content;
    } catch (error) {
    }
    commit('user/CHANGE_STATE', { chargeVisible: true }, { root: true });
    const allChargeList = mergeQrCode(info, qrcode_status, qrcode_info);

    // 根据配置判断是否屏蔽支付宝
    // const shouldHideAlipay = APPKEY_PARAMS[appkey]?.hide_alipay || false;
    // // 过滤支付方式列表
    // let filteredChargeList = allChargeList;
    // if (shouldHideAlipay) {
    //   // 屏蔽支付宝
    //   filteredChargeList = allChargeList.filter(item => item.img_class_name !== "alipay");
    // }

    const transferChargeList = allChargeList.filter(item => item.img_class_name != "wechat");
    // if (orderInfo) dispatch('placeOrder');
    commit('CHANGE_STATE', {
      thirdChargeVisible: true,
      chargeList: transferInfo.hide_wechat == 1 ? transferChargeList : allChargeList,
      allChargeList: allChargeList,
      transferChargeList: transferChargeList,
      hideWxPayType: transferInfo.hide_wechat == 1,
      ali_gift_image: transferInfo.ali_gift_image,
      ali_gift: transferInfo.ali_gift,
      large_status,
      large_info,
      qrcode_status,
      qrcode_info
    });
    
  },
  // 应用宝内购回调请求
  async yybInnerPay({ rootState, commit, state }) {
    const {
      user: { appkey, channel, user_id }
    } = rootState;
    const { yyb_info } = state;
    try {
      const r = await yybInnerPayRes({
        jh_app_id: appkey,
        uid: user_id,
        appid: yyb_info.appid,
        amt: yyb_info.amt,
        billno: yyb_info.billno,
        openid: yyb_info.openid,
        openkey: yyb_info.openkey,
        pf: yyb_info.pf,
        pfkey: yyb_info.pfkey,
        zoneid: yyb_info.zoneid,
        user_type: yyb_info.user_type,
        money: yyb_info.money,
        is_sandbox: yyb_info.is_sandbox,
        plain_id: channel
      });
      commit('global/showCommonToast', '支付成功，请以游戏内游戏币状态为准!', { root: true });
    } catch (error) {
      commit('global/showCommonToast', '支付失败,请以游戏内游戏币状态为准!', { root: true });
      registFunFailFunction(null);
    }
  },

  // 查询支付结果 type.1 轮询查询不通知支付失败
  async queryOrderResult({ state, rootState, commit, dispatch }, type) {
    const {
      user: { appkey, access_token, user_id }
    } = rootState;
    const { order_info, thirdLibs, pay_type, order_sn, ali_gift, img_class_name } = state;
    // console.log('开始查询订单结果:', { order_info, user_id, order_sn });
    if (!order_sn) return;
    // 转移包发放礼包情况，从支付宝返回后延迟1s检查订单结果
    if (ali_gift == 1 && img_class_name == 'alipay') {
      commit('global/showLoading', null, { root: true })
      await (() => {
        return new Promise((resolve) => {
          setTimeout(() => resolve(true), 1500);
        });
      })()
      commit('global/clearLoading', null, { root: true });
    }
    let r = '';
    try {
      r = await queryOrderResult({
        jh_app_id: appkey,
        order_sn: state.order_sn,
        access_token,
        uid: user_id,
        ios_uid: user_id
      });
    } catch (err) {
      registReturnGameFunction(null);
    }
    if (r.content.pay_status == 0) {
      if (type) return;
      if (ali_gift == 1) {
        commit('global/clearLoading', null, { root: true });
        commit('CHANGE_STATE', { payResult: false, giftCodeVisible: true });
      } else {
        commit('global/showCommonToast', '支付失败,请以游戏内游戏币状态为准!', { root: true });
      }
      //彩消需要处理回调
      if (appkey == '200020221') {
        const params = {
          code: 2,
          msg: '未支付',
        };
        window.frames['gameFrame'].postMessage({ action: 'getOrderStateCallback', params }, '*');
      }
      registFunFailFunction(null);
    } else if (r.content.pay_status == 1) {
      // console.log('支付成功:status=1');
      if (window.queryInterval) clearInterval(window.queryInterval);
      let orderInfo = _.cloneDeep(order_info);
      if (isAndroid()) {
        orderInfo.zfAmount =
          handleThirdLib(orderInfo.zfAmount / 100, thirdLibs) || orderInfo.zfAmount / 100;
        orderInfo.total_fee = orderInfo.zfAmount;
      } else {
        orderInfo.zfAmount = handleThirdLib(orderInfo.zfAmount, thirdLibs) || orderInfo.zfAmount;
        orderInfo.productName = orderInfo.product;
        orderInfo.productId = orderInfo.product_id;
        orderInfo.productCount = 1;
      }
      orderInfo.type = state.img_class_name;
      orderInfo.pay_type = pay_type;
      orderInfo.uid = user_id;
      orderInfo.yw_order_sn = order_sn;
      reportUserTopUp(order_info.zfAmount * 10)
      commit('CHANGE_STATE', { reportOrder: orderInfo });
      //彩消需要处理回调
      if (appkey == '200020221') {
        const params = {
          code: 1,
          msg: '支付成功',
        };
        window.frames['gameFrame'].postMessage({ action: 'getOrderStateCallback', params }, '*');
      }
      // 转移包支付成功弹框相关逻辑
      if (ali_gift == 1) {
        if (img_class_name == 'alipay') {
          dispatch('getTransferGift', { appkey: appkey, order_sn: state.order_sn })
        } else {
          commit('CHANGE_STATE', { payResult: true, giftCodeVisible: true });
          commit('global/clearLoading', null, { root: true });
        }
      } else {
        commit('global/showCommonToast', '支付成功,请以游戏内游戏币状态为准!', { root: true });
        registFunSuccessReportFunction(orderInfo);
      }

    }
    commit('CHANGE_STATE', {
      orderShow: false,
      orderIframeLink: ''
    });

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.miraclesReportHandler && r.content.pay_status == 1) {
      window.webkit.messageHandlers.miraclesReportHandler.postMessage({
        user_unique_id: user_id,
        pay_amount: order_info.zfAmount || order_info.total_fee   // 付费金额 单位/分
      });
      // console.log('已触发iOS支付上报:', { user_unique_id: user_id, pay_amount: order_info.zfAmount });
      commit('CHANGE_STATE', { order_sn: '' });
      setStorage('ios_pay_order_sn', '1');
      setStorage('ios_pay_loopTimes', 0);
      if (window.queryInterval) clearInterval(window.queryInterval);
    }

    const cpsChannel = localStorage.getItem('cpsChannel');
    if (cpsChannel) {
      cpsOrderCheck[cpsChannel] && cpsOrderCheck[cpsChannel](order_sn)
    }
    // 非转移包获取订单结果后关闭支付框，防止重复点击
    if (ali_gift != 1) {
      // 埋点上报
      buryReportV2('ORDER_PAY_RESULT', {
        order_sn: order_sn,
        pay_status: r.content.pay_status
      })
      commit(
        'user/CHANGE_STATE',
        {
          chargeVisible: false
        },
        { root: true }
      );
      setTimeout(() => {
        registReturnGameFunction(null);
      }, 2000);
    }
    // 转移包支付返回失败后弹框，允许点击刷新按钮重新检查订单 不能清掉订单号
    if (ali_gift != 1 || r.content.pay_status == 1) {
      commit('CHANGE_STATE', { order_sn: '' });
    }
  },
  // tiktok支付
  async tiktokPlaceOrder({ commit, state, rootState, dispatch }, couponInfo = {}) {
    if (isWeiXin()) {
      commit('CHANGE_STATE', { guideBrowserVisible: true });
      return;
    }
    const {
      global: { preventBrush },
      user: { extra_data, appkey, user_id, sdk_version, access_token, username }
    } = rootState;
    const {order_info, open } = state;
    // 防止重复下单
    if (preventBrush) return;
    commit('global/CHANGE_STATE', { preventBrush: true }, { root: true });
    const orderInfo = {
      cp_trade_no: order_info.orderId || order_info.cp_trade_no,
      notify_url: order_info.notifyUrl || order_info.notify_url,
      body: order_info.zfDesc || order_info.body,
      product_id: order_info.productId || order_info.product_id,
      product: order_info.productName || order_info.product,
      exchange_rate: order_info.rate || order_info.exchange_rate,
      app_role_id: order_info.roleId || order_info.app_role_id,
      app_role_name: order_info.roleName || order_info.app_role_name,
      server_id: order_info.serverId || order_info.server_id,
      total_fee: order_info.zfAmount || order_info.total_fee
    };

    commit('CHANGE_STATE', { pay_type: 108 });
    const {pay_type} = state;
    // 下单开始
    const r = await placeOrder({
      extra_data: extra_data,
      jh_app_id: appkey,
      order_data: JSON.stringify(orderInfo),
      time_stamp: moment().unix(),
      pay_type: pay_type,
      uid: user_id,
      sdk_version: sdk_version,
      access_token: access_token,
      user_voucher_id: couponInfo.id || '',
      task_id: order_info.ks_task_id || ''
    });
    console.log('paytype==> :', pay_type);
    const { order_sn, exchange_rate, notify_url, code } = r.content;
    console.log('place order res', r.content);

    if (code) {
      console.log('需要防沉迷支付:');
      commit(
        'user/CHANGE_STATE',
        {
          antiIndulgedPayInfo: r.content,
          h5_branch: 'payment', // h5
          antiIndulgedVisible: true // h5
        },
        { root: true }
      );
      if (open == 0 && !isAndroid()) {
        registSetWindowAlpha(1)
      }
      commit('CHANGE_STATE', { antiIndulgedPayVisible: true });
      return;
    }

    commit('CHANGE_STATE', {
      order_sn,
      order_info: {
        ...order_info,
        exchange_rate: exchange_rate || order_info.exchange_rate
      }
    });
    // 支付处理
    console.log('tiktok支付渠道:');
    getStorage('tiktok_openid') && console.log('storage获取-----openId', getStorage('tiktok_openid'));
    const tiktokRes = await getTiktokSign({
      accessToken: access_token,
      orderSn: order_sn,
      userId: user_id,
      jhAppId: appkey,
      openid: getStorage('tiktok_openid') || ''
    });
    const { good_type, cp_order_no, sign, zone_id, extra_info, buy_quantity } = tiktokRes.content || {};
    console.log('tiktok pay sign res', tiktokRes);
    if (tiktokRes.ret === 1) {
        console.log('获取抖音支付参数成功，准备调起抖音支付');
        tiktokPay({
        goodType: good_type,
        cpOrderNo: cp_order_no,
        sign,
        zoneId: zone_id,
        extraInfo: extra_info,
        buyQuantity: buy_quantity
        });
    } else {
      console.error('获取抖音支付参数失败:', tiktokRes.msg);
      commit('global/showCommonToast', '支付失败，请重试~', { root: true });
      return;
    }
    getOrdersInfo({
      orderInfo: Object.assign(order_info, { yw_order_sn: r.content.order_sn }),
      pay_type: pay_type,
      uid: user_id
    });
    const cpsChannel = localStorage.getItem('cpsChannel');
    if (cpsChannel) {
      cpsPayOrder[cpsChannel] && cpsPayOrder[cpsChannel](order_info, order_sn)
    }


  },
  // 点击确认充值下单
  async placeOrder({ commit, state, rootState, dispatch }, couponInfo = {}) {
    if (isWeiXin()) {
      commit('CHANGE_STATE', { guideBrowserVisible: true });
      return;
    }
    const {
      global: { preventBrush },
      user: { extra_data, appkey, user_id, sdk_version, access_token, username }
    } = rootState;
    const { pay_type, order_info, open } = state;
    // 防止重复下单
    if (preventBrush) return;
    commit('global/CHANGE_STATE', { preventBrush: true }, { root: true });
    const orderInfo = {
      cp_trade_no: order_info.orderId || order_info.cp_trade_no,
      notify_url: order_info.notifyUrl || order_info.notify_url,
      body: order_info.zfDesc || order_info.body,
      product_id: order_info.productId || order_info.product_id,
      product: order_info.productName || order_info.product,
      exchange_rate: order_info.rate || order_info.exchange_rate,
      app_role_id: order_info.roleId || order_info.app_role_id,
      app_role_name: order_info.roleName || order_info.app_role_name,
      server_id: order_info.serverId || order_info.server_id,
      total_fee: order_info.zfAmount || order_info.total_fee
    };
    // 下单开始
    const r = await placeOrder({
      extra_data: extra_data,
      jh_app_id: appkey,
      order_data: JSON.stringify(orderInfo),
      time_stamp: moment().unix(),
      pay_type: pay_type,
      uid: user_id,
      sdk_version: sdk_version,
      access_token: access_token,
      user_voucher_id: couponInfo.id || '',
      task_id: order_info.ks_task_id || ''
    });
    const { order_sn, exchange_rate, notify_url, code } = r.content;

    if (code) {
      commit(
        'user/CHANGE_STATE',
        {
          antiIndulgedPayInfo: r.content,
          h5_branch: 'payment', // h5
          antiIndulgedVisible: true // h5
        },
        { root: true }
      );
      if (open == 0 && !isAndroid()) {
        registSetWindowAlpha(1)
      }
      commit('CHANGE_STATE', { antiIndulgedPayVisible: true });
      return;
    }

    // const orderCallback = rootState.message.orderCallback;
    // //彩消订单特殊处理
    // if (orderCallback) {
    //   const _onderOn = order_info.orderId || order_info.cp_trade_no;

    //   window.cxQueryInterval = setInterval(() => {
    //     if (rootState.pay.cxTimes < 120) {
    //       dispatch('cXqueryOrder', _onderOn)
    //       commit('CHANGE_STATE', { cxTimes: rootState.pay.cxTimes + 2 });
    //     } else {
    //       clearInterval(window.cxQueryInterval);
    //     }
    //   }, 2000);
    // }

    commit('CHANGE_STATE', {
      order_sn,
      order_info: {
        ...order_info,
        exchange_rate: exchange_rate || order_info.exchange_rate
      }
    });
    // 支付处理
    if (open == 1) {
      if (pay_type == 43) {
        registSmallProgramFunction({
          access_token: access_token,
          orderInfo,
          order_sn
        });
      } else if (getStorage('externalLogin')) {
        dispatch('externalPay');
      } else {
        if (state.isOpenTQPay){
          const morder = APPKEY_PARAMS[appkey] ? `${APPKEY_PARAMS[appkey].tq_order_prefix}${order_sn}` : order_sn;
          try {
            // 天穹下单处理 - 等待回调结果
            const tqResult = await dispatch('handleTianqiongPayment', {
              orderInfo,
              order_sn: morder,
              user_id,
              image_class_name: state.img_class_name
            });
            // 根据天穹下单结果处理
            if (tqResult.success && tqResult.pay_url) {
              dispatch('toTQPay');
            }else {
              // 确保支付可用优先
              await uploadTQLog({msg:'天穹下单失败', tqres:tqResult.originalResponse, errorMsg:tqResult.errorMsg, orderInfo, order_sn: morder, user_id });
              dispatch('toPay');
            }
          } catch (error) {
            // 天穹下单失败，可以继续走原有支付流程
            await uploadTQLog({msg:'天穹下单catch错误', orderInfo, order_sn: morder, user_id });
            dispatch('toPay');
          }
        }else{
          // console.log('未初始化天穹SDK，走原有支付流程');
          if (APPKEY_PARAMS[appkey]) {
            await uploadTQLog({msg:'天穹游戏走原有支付,未初始化天穹SDK', orderInfo, order_sn: order_sn, user_id });
          }
          dispatch('toPay');
        }
      }
    } else {
        registInnerPurchaseFunction({
                ...order_info,
                uid: user_id,
                username: username,
                order_sn: order_sn,
                notifyUrl: notify_url
              });
    }
    getOrdersInfo({
      orderInfo: Object.assign(order_info, { yw_order_sn: r.content.order_sn }),
      pay_type: pay_type,
      uid: user_id
    });
    const cpsChannel = localStorage.getItem('cpsChannel');
    if (cpsChannel) {
      cpsPayOrder[cpsChannel] && cpsPayOrder[cpsChannel](order_info, order_sn)
    }


  },
  /**
   * 天穹下单
   */
  async handleTianqiongPayment({ state, dispatch, commit }, {
    orderInfo,
    order_sn,
    user_id,
    image_class_name
  }) {
    return new Promise((resolve, reject) => {
      // 确保TQLib已初始化
      if (state.isOpenTQPay && state.tqlib) {
        let payChannelId = state.isQrCode ? 4 : 3; // 默认支付渠道ID
        if (image_class_name === 'wechat') {
          payChannelId = state.isQrCode ? 4 : 3; // 微信扫码支付或h5支付 == 根据TQ文档支付类型固定-写死即可
        }else if (image_class_name === 'alipay') {
          payChannelId = state.isQrCode ? 2 : 1; // 支付宝扫码支付或支付宝H5支付
        }
        // 构建TQLib订单信息
        const tqOrderInfo = {
          userId: user_id,
          gameOrderId: orderInfo.cp_trade_no,
          roleId: orderInfo.app_role_id,
          roleName: orderInfo.app_role_name,
          productId: orderInfo.product_id,
          productName: orderInfo.product,
          serverName: orderInfo.server_id,
          serverId: orderInfo.server_id,
          zfAmount: orderInfo.total_fee,
          tp: '{"direct_return_url":1}', // 微信、支付宝三方支付无需传 tp 参数；iOS 内购支付需要必传，详情看入参说明
          payChannelId: payChannelId,
          companyOrderId: order_sn,
          companyNotifyUrl: 'https://h5i.13yx.com/wx/tq_order',
          expireTimestampMillis: '', // 改为当前时间戳
          syncNotifyUrl: '',
          cancelUrl: '',
        };
        // 获取支付方式（可选）
        // state.tqlib.getPayType(function (res) {
        //   console.log('tq pay type res', res);
        // });
        // 使用保存到state中的tqlib实例显示订单
        state.tqlib.showOrder(tqOrderInfo, function (res) {
          console.log('tq pay res', res);
          if (res && res.data && res.data.pay_url) {
            const { pay_url } = res.data;
            commit('CHANGE_STATE', { tq_pay_url: pay_url });
            // 解析成功，返回支付结果
            resolve({
              success: true,
              pay_url: pay_url,
              originalResponse: res
            });
          } else {
            // 支付失败或无支付链接
            const errorMsg = res && res.message ? res.message : '天穹支付返回结果异常';
            reject(new Error(errorMsg));
          }
        });
      } else {
        // TQLib未初始化或不可用
        resolve({
          success: false,
          message: 'TQLib未初始化或不可用'
        });
      }
    });
  },
  /**
   * 内购下单方法 - 专门用于内购场景，返回订单信息
   * @param {*} param0 
   * @param {*} orderInfo 订单信息
   */
  async placeInnerOrder({ commit, rootState }, orderInfo) {
    const {
      user: { extra_data, appkey, user_id, sdk_version, access_token, username }
    } = rootState;
    
    // 构建订单信息
    const orderData = {
      cp_trade_no: orderInfo.orderId || orderInfo.cp_trade_no,
      notify_url: orderInfo.notifyUrl || orderInfo.notify_url,
      body: orderInfo.zfDesc || orderInfo.body,
      product_id: orderInfo.productId || orderInfo.product_id,
      product: orderInfo.productName || orderInfo.product,
      exchange_rate: orderInfo.rate || orderInfo.exchange_rate,
      app_role_id: orderInfo.roleId || orderInfo.app_role_id,
      app_role_name: orderInfo.roleName || orderInfo.app_role_name,
      server_id: orderInfo.serverId || orderInfo.server_id,
      total_fee: orderInfo.zfAmount || orderInfo.total_fee
    };
    
    try {
      // 调用下单接口
      const r = await placeOrder({
        extra_data: extra_data,
        jh_app_id: appkey,
        order_data: JSON.stringify(orderData),
        time_stamp: moment().unix(),
        pay_type: 7, // 内购支付类型
        uid: user_id,
        sdk_version: sdk_version,
        access_token: access_token,
        user_voucher_id: '',
        task_id: orderInfo.ks_task_id || ''
      });
      
      const { order_sn, exchange_rate, notify_url, code } = r.content;

      commit('CHANGE_STATE', {
      order_sn,
      order_info: {
        ...orderInfo,
        exchange_rate: exchange_rate || orderInfo.exchange_rate
      }
    });
                    
      registInnerPurchaseFunction({
        ...orderInfo,
        uid: user_id,
        username: username,
        order_sn: order_sn,
        notifyUrl: notify_url
      });
    
      getOrdersInfo({
        orderInfo: Object.assign(orderInfo, { yw_order_sn: r.content.order_sn }),
        pay_type: 7,
        uid: user_id
      });
      const cpsChannel = localStorage.getItem('cpsChannel');
      if (cpsChannel) {
        cpsPayOrder[cpsChannel] && cpsPayOrder[cpsChannel](orderInfo, order_sn)
      }
      
      // 返回下单结果
      if (r && r.content) {
        return {
          success: true,
          data: r.content
        };
      } else {
        return {
          success: false,
          error: '下单失败，返回结果异常'
        };
      }
    } catch (error) {
      console.error('内购下单失败:', error);
      return {
        success: false,
        error: error.message || '下单失败'
      };
    }
  },
    // 天穹支付方法
  async toTQPay({ state, rootState, commit, dispatch }) {
    const { pay_type, order_sn, img_class_name, isQrCode, tq_pay_url } = state;
    const {
      user: { extra_data, access_token, user_id, appkey, sdk_version, device_info },
      global: { outer }
    } = rootState;

    // 检查是否为微信支付链接
    // const isWechatPayUrl = tq_pay_url && tq_pay_url.includes('wx.tenpay.com');

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.miraclesopenHandler) {
      // iOS原生处理
      setStorage('ios_pay_order_sn', order_sn);
      setStorage('ios_pay_loopTimes', 0);

      if (window.queryInterval) clearInterval(window.queryInterval);
      window.queryInterval = setInterval(() => {
        if (getStorage('ios_pay_order_sn') == '1') {
          setStorage('ios_pay_loopTimes', 0);
          clearInterval(window.queryInterval);
        }
        if (getStorage('ios_pay_loopTimes') < 180) {
          dispatch('queryOrderResult', 1);
          setStorage('ios_pay_loopTimes', getStorage('ios_pay_loopTimes') + 5);
        } else {
          setStorage('ios_pay_order_sn', '1');
          setStorage('ios_pay_loopTimes', 0);
          clearInterval(window.queryInterval);
        }
      }, 5000);

      if (img_class_name === 'wechat' && pay_type != 11) {
        commit('global/showLoading', '支付中...', { root: true });
      } else {
        commit('CHANGE_STATE', { orderShow: true });
      }

      window.open(tq_pay_url, '_blank');
      // commit('CHANGE_STATE', { orderIframeLink: tq_pay_url });

      if (outer == 'turn' && pay_type != 21) {
        setTimeout(() => {
          commit('CHANGE_STATE', {
            orderShow: false,
            orderIframeLink: ''
          });
          commit(
            'user/CHANGE_STATE',
            {
              chargeVisible: false
            },
            { root: true }
          );
          commit('global/showCommonToast', '支付结果,请以游戏内游戏币状态为准!', { root: true });
        }, 5000);
      }

    } else {
      // 非iOS原生环境
      if (!isQrCode) {
        // 微信支付渠道特殊处理
        if (img_class_name === 'wechat' && pay_type != 11) {
          commit('global/showLoading', '支付中...', { root: true });
        } else {
          commit('CHANGE_STATE', { orderShow: true });
        }
        // commit('CHANGE_STATE', { orderIframeLink: tq_pay_url });
        // window.open(tq_pay_url, '_blank');
        // 针对微信支付链接的特殊处理
        // if (isWechatPayUrl) {
        //   // 方法1: 使用form提交方式（推荐）
          // dispatch('handleWechatPayForm', tq_pay_url);

        //   // 或者方法2: 修改链接使其可跨域访问
          
          if (img_class_name === 'wechat') {
            commit('CHANGE_STATE', { orderIframeLink: tq_pay_url + '&redirect_url=' + encodeURIComponent('https://sdk-h5.zhangyuqu.com') });
          }else if (img_class_name === 'alipay'){
            commit('CHANGE_STATE', { orderIframeLink: tq_pay_url });
          }
          
        // } else {
        //   // 其他支付方式正常处理
        //   commit('CHANGE_STATE', { orderIframeLink: tq_pay_url });
        // }

        if (outer == 'turn' && pay_type != 21) {
          setTimeout(() => {
            commit('CHANGE_STATE', {
              orderShow: false,
              orderIframeLink: ''
            });
            commit(
              'user/CHANGE_STATE',
              {
                chargeVisible: false
              },
              { root: true }
            );
            commit('global/showCommonToast', '支付结果,请以游戏内游戏币状态为准!', { root: true });
          }, 5000);
        }
      } else {
        // 二维码支付
        if (img_class_name === 'wechat') {
          console.log('获取微信二维码链接');
          const r = await getWxQrCode({
            order_sn,
            os: device_info.os,
            access_token,
            uid: user_id,
            jh_app_id: appkey,
            sdk_version,
            pay_type
          });
          commit('CHANGE_STATE', { qrCodeVisible: true, qrCodeLink: await QRCode.toDataURL(tq_pay_url) });
        } else {
          commit('CHANGE_STATE', { qrCodeVisible: true, qrCodeLink: await QRCode.toDataURL(tq_pay_url) });
        }

        window.queryInterval = setInterval(() => {
          if (state.loopTimes < 300) {
            dispatch('queryOrderResult', 1);
            commit('CHANGE_STATE', { loopTimes: state.loopTimes + 2 });
          } else {
            clearInterval(window.queryInterval);
            commit('global/showCommonToast', '支付失败,请以游戏内游戏币状态为准!', { root: true });
            commit('CHANGE_STATE', {
              order_sn: '',
              orderShow: false,
              orderIframeLink: ''
            });
            commit(
              'user/CHANGE_STATE',
              {
                chargeVisible: false
              },
              { root: true }
            );
            setTimeout(() => {
              registReturnGameFunction(null);
            }, 1500);
          }
        }, 2000);
      }
    }
  },

  // 新增方法：处理微信支付表单
  async handleWechatPayForm({ commit }, payUrl) {
    // 创建隐藏的form表单提交
    const form = document.createElement('form');
    form.id = 'wechatPayForm';
    form.method = 'GET';
    form.action = payUrl;
    form.target = '_blank';
    form.style.display = 'none';

    // 添加必要的参数
    const params = new URL(payUrl).searchParams;
    params.forEach((value, key) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    // 添加redirect_url参数（重要）
    const redirectInput = document.createElement('input');
    redirectInput.type = 'hidden';
    redirectInput.name = 'redirect_url';
    redirectInput.value = 'https://sdk-h5.zhangyuqu.com';
    form.appendChild(redirectInput);

    document.body.appendChild(form);

    // 延迟提交，确保页面稳定
    setTimeout(() => {
      form.submit();
      // 提交后移除表单
      setTimeout(() => {
        if (document.getElementById('wechatPayForm')) {
          document.body.removeChild(form);
        }
      }, 1000);
    }, 100);

    // 关闭订单显示
    commit('CHANGE_STATE', { 
      orderShow: false,
      orderIframeLink: ''
    });
  },

  // 也可以使用iframe方式的替代方案
  async handleWechatPayIframe({ commit }, payUrl) {
    // 创建iframe
    const iframe = document.createElement('iframe');
    iframe.id = 'wechatPayIframe';
    iframe.src = payUrl + '&redirect_url=' + encodeURIComponent(window.location.href);
    iframe.style.width = '100%';
    iframe.style.height = '500px';
    iframe.style.border = 'none';

    // 添加到页面
    const container = document.getElementById('orderIframeContainer') || document.body;
    container.appendChild(iframe);

    commit('CHANGE_STATE', { 
      orderShow: true,
      orderIframeLink: payUrl + '&redirect_url=' + encodeURIComponent(window.location.href)
    });
  },
  // 去支付
  async toPay({ state, rootState, commit, dispatch }) {
    const { pay_type, order_sn, img_class_name, isQrCode } = state;
    const {
      user: { extra_data, access_token, user_id, appkey, sdk_version, device_info },
      global: { outer }
    } = rootState;

    let url =
      ENV_URL +
      '/pay/pay?order_sn=' +
      order_sn +
      '&os=' +
      device_info.os +
      '&access_token=' +
      access_token +
      '&uid=' +
      user_id +
      '&jh_app_id=' +
      appkey +
      '&sdk_version=' +
      sdk_version +
      '&pay_type=' +
      pay_type;

    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.miraclesopenHandler) {

      // 8-12排查问题-此处导致支付完成后闪退
        setStorage('ios_pay_order_sn', order_sn);
        setStorage('ios_pay_loopTimes', 0);
        // 这里需要添加查询订单
        if (window.queryInterval) clearInterval(window.queryInterval);
        window.queryInterval = setInterval(() => {
          // 若订单已成功（order_sn 被清空）或已结束，则停止轮询
          if (getStorage('ios_pay_order_sn') == '1') {
            setStorage('ios_pay_loopTimes', 0);
            clearInterval(window.queryInterval);
          }
          if (getStorage('ios_pay_loopTimes') < 180) {
            dispatch('queryOrderResult', 1);
            setStorage('ios_pay_loopTimes', getStorage('ios_pay_loopTimes') + 5);
          } else {
            setStorage('ios_pay_order_sn', '1');
            setStorage('ios_pay_loopTimes', 0);
            clearInterval(window.queryInterval);

          }
        }, 5000);

        // if (appkey == 200027687){
        //   window.webkit.messageHandlers.miraclesopenHandler.postMessage({
        //   link: url
        //   });
        //   commit('CHANGE_STATE', {
        //   orderShow: false,
        //   orderIframeLink: ''
        //   });
        //   commit(
        //     'user/CHANGE_STATE',
        //     {
        //       chargeVisible: false
        //     },
        //     { root: true }
        //   );
        //   commit('global/showCommonToast', '支付结果,请以游戏内游戏币状态为准!', { root: true });
        // }else {
          if (img_class_name === 'wechat' && pay_type != 11) {
                    commit('global/showLoading', '支付中...', { root: true });
          } else {
            commit('CHANGE_STATE', { orderShow: true });
          }

          commit('CHANGE_STATE', { orderIframeLink: url });
          if (outer == 'turn' && pay_type != 21) {
            setTimeout(() => {
              commit('CHANGE_STATE', {
                orderShow: false,
                orderIframeLink: ''
              });
              commit(
                'user/CHANGE_STATE',
                {
                  chargeVisible: false
                },
                { root: true }
              );
              commit('global/showCommonToast', '支付结果,请以游戏内游戏币状态为准!', { root: true });
            }, 5000);
          }
        // }
          
    } else {
      console.warn('miraclesopenHandler not found');
      if (!isQrCode) {
      // 11. now微信支付渠道 需要显示支付界面
        if (img_class_name === 'wechat' && pay_type != 11) {
          commit('global/showLoading', '支付中...', { root: true });
        } else {
          commit('CHANGE_STATE', { orderShow: true });
        }

        commit('CHANGE_STATE', { orderIframeLink: url });
        if (outer == 'turn' && pay_type != 21) {
          setTimeout(() => {
            commit('CHANGE_STATE', {
              orderShow: false,
              orderIframeLink: ''
            });
            commit(
              'user/CHANGE_STATE',
              {
                chargeVisible: false
              },
              { root: true }
            );
            commit('global/showCommonToast', '支付结果,请以游戏内游戏币状态为准!', { root: true });
          }, 5000);
        }   
      } else {
        // 二维码支付
        if (img_class_name === 'wechat') {
          const r = await getWxQrCode({
            order_sn,
            os: device_info.os,
            access_token,
            uid: user_id,
            jh_app_id: appkey,
            sdk_version,
            pay_type
          });
          commit('CHANGE_STATE', { qrCodeVisible: true, qrCodeLink: await QRCode.toDataURL(r.content.jh_notify_url) });
        } else {
          console.log(382, url)
          commit('CHANGE_STATE', { qrCodeVisible: true, qrCodeLink: await QRCode.toDataURL(url) });
        }
        window.queryInterval = setInterval(() => {
          if (state.loopTimes < 300) {
            dispatch('queryOrderResult', 1);
            commit('CHANGE_STATE', { loopTimes: state.loopTimes + 2 });
          } else {
            clearInterval(window.queryInterval);
            commit('global/showCommonToast', '支付失败,请以游戏内游戏币状态为准!', { root: true });
            commit('CHANGE_STATE', {
              order_sn: '',
              orderShow: false,
              orderIframeLink: ''
            });
            commit(
              'user/CHANGE_STATE',
              {
                chargeVisible: false
              },
              { root: true }
            );
            setTimeout(() => {
              registReturnGameFunction(null);
            }, 1500)
          }
        }, 2000);
      }
    }
  },
  // 浏览器支付
  async externalPay({ state, rootState, commit, dispatch }) {
    const { pay_type, order_sn, img_class_name, isQrCode } = state;
    const {
      user: { extra_data, access_token, user_id, appkey, sdk_version, device_info },
      global: { outer }
    } = rootState;
    // 浏览器内玩游戏，调用/pay/pay接口直接返回schema链接打开
    const r = await getWxQrCode({
      order_sn,
      os: device_info.os,
      access_token,
      uid: user_id,
      jh_app_id: appkey,
      sdk_version,
      pay_type,
      from_browser: 2
    });
    console.log(r.content);
    if (pay_type == 57) {

      deleteDivIfExists('alipay');

      const div = document.createElement('div');
      div.id = 'alipay';
      div.innerHTML = r.content;
      document.body.appendChild(div);
      document.querySelector('#alipay').children[0].submit(); // 执行后会唤起支付宝
    } else {
      window.open(r.content, "_self");
    }

    ///
    commit('user/CHANGE_STATE', { chargeVisible: false }, { root: true });
  },
  async submitLargeCharge({ state, rootState, commit, dispatch }, money) {
    const {
      global: { preventBrush },
      user: { extra_data, appkey, user_id, sdk_version, access_token, username }
    } = rootState;
    const { pay_type, order_info, open } = state;
    // 防止重复下单
    if (preventBrush) return;
    commit('global/CHANGE_STATE', { preventBrush: true }, { root: true });
    const orderInfo = {
      cp_trade_no: order_info.orderId || order_info.cp_trade_no,
      notify_url: order_info.notifyUrl || order_info.notify_url,
      body: order_info.zfDesc || order_info.body,
      product_id: order_info.productId || order_info.product_id,
      product: order_info.productName || order_info.product,
      exchange_rate: order_info.rate || order_info.exchange_rate,
      app_role_id: order_info.roleId || order_info.app_role_id,
      app_role_name: order_info.roleName || order_info.app_role_name,
      server_id: order_info.serverId || order_info.server_id,
      total_fee: order_info.zfAmount || order_info.total_fee
    };
    // 下单开始
    const r = await placeLargeOrder({
      extra_data: extra_data,
      jh_app_id: appkey,
      order_data: JSON.stringify(orderInfo),
      time_stamp: moment().unix(),
      pay_type: pay_type,
      uid: user_id,
      sdk_version: sdk_version,
      access_token: access_token,
      money: Math.ceil(Number(money) * 100)
    });
    const { order_sn, exchange_rate } = r.content;

    commit('CHANGE_STATE', {
      order_sn,
      order_info: {
        ...order_info,
        exchange_rate: exchange_rate || order_info.exchange_rate
      },
      largeChargeVisible: false
    });
    dispatch('toPay');
    getOrdersInfo({
      orderInfo: Object.assign(order_info, { yw_order_sn: r.content.order_sn }),
      pay_type: pay_type,
      uid: user_id
    });
    commit('global/CHANGE_STATE', { preventBrush: false }, { root: true });
  },
  // 盒子云手机预下单请求
  async cloudPreCreatOrder({ state, rootState, commit, dispatch }, data) {
    const {
      user: { user_id, appkey, device_info },
    } = rootState;
    try {
      const r = await cloudOrderPreCreate({
        os: device_info.os,
        type: 2,
        userId: user_id,
        channelType: 2,
        money: data.money,
        gameId: appkey,
        deviceId: device_info.device_id,
        goodsId: data.goodsId,
        goodsName: data.goodsName,
        num: data.num,
        operateType: data.operateType,
        userPhoneId: data.userPhoneId,
        days: data.days
      })
      if (r.code == 0) {
        commit('CHANGE_STATE', {
          cloudPayInfo: {
            ...data,
            preOrderSn: r.data.preOrderSn,
            callbackUrl: r.data.callbackUrl,
            payAppId: r.data.payAppId,
            totalMoney: r.data.money
          }
        })
        return true;
      } else if (r.code == 2003) {
        commit('global/showCommonToast', '当前云手机即将被释放，无法续费，请重新购买', { root: true });
        return false;
      } else {
        commit('global/showCommonToast', r.msg, { root: true });
        return false;
      }
    } catch (error) {
      return false;
    }
  },
  // 云手机手游创建订单接口
  async placeCloudOrder({ state, rootState, commit, dispatch }, data) {
    const { cloudPayInfo, img_class_name } = state;
    const {
      user: { user_id, appkey, device_info },
      suspend: { cloud_hang_up_template_id }
    } = rootState;
    const r = await commonPayOrder({
      out_order_sn: cloudPayInfo.preOrderSn,
      money: cloudPayInfo.totalMoney,
      pay_type: data.pay_type,
      notify_url: cloudPayInfo.callbackUrl,
      pay_app_id: cloudPayInfo.payAppId,
      goods_name: cloudPayInfo.goodsName,
      appkey: appkey,
      user_id: user_id,
      cloud_hang_up_template_id: cloud_hang_up_template_id
    })
    commit('CHANGE_STATE', {
      cloudPayInfo: {
        ...cloudPayInfo,
        sy_order_sn: r.content.order_sn
      }
    });
    if (img_class_name === 'wechat') {
      commit('global/showLoading', '支付中...', { root: true });
    } else {
      commit('CHANGE_STATE', { orderShow: true });
    }
    commit('CHANGE_STATE', { orderIframeLink: r.content.pay_url });
  },
  // 转移包支付返回游戏后，礼包相关处理
  async getTransferGift({ state, rootState, commit, dispatch }, data) {
    const r = await miniLeadPayGift(data);
    const { has_gift, gift_code } = r.content;
    if (has_gift == 0) {
      commit('global/showCommonToast', '支付成功,请以游戏内游戏币状态为准!', { root: true });
      setTimeout(() => {
        dispatch('giftHintClose')
      }, 1500)
    } else {
      commit('CHANGE_STATE', {
        transferGiftCode: gift_code,
        giftCodeVisible: true,
        payResult: true
      });
    }
  },
  giftHintClose({ state, commit, rootState }, type) {
    commit('CHANGE_STATE', { giftCodeVisible: false });
    commit('user/CHANGE_STATE', { chargeVisible: false, giftCodeVisible: false }, { root: true });
    if (state.payResult) {
      registFunSuccessReportFunction(state.reportOrder);
    }
    if (type) {
      openFloatBall('welfare')
      commit('user/CHANGE_STATE', { floatWindowVisible: true }, { root: true });
      setTimeout(() => {
        const tabs = rootState.suspend.tabs;
        const activeTab = tabs.find(item => item.type == 'welfare');
        if (activeTab && activeTab.show == true) {
          commit('suspend/CHANGE_STATE', { activeTab }, { root: true });
        }
      }, 500)
    } else if (isPure()) {
      registReturnGameFunction(null);
    }
  },

  async cXqueryOrder({ state, rootState, commit, dispatch }, obj) {
    console.log('-obj--', obj)
    const {
      user: { appkey, access_token, user_id }
    } = rootState;
    if (!obj) return;

    console.log('-----', obj);
    let r = '';
    try {
      r = await cXqueryOrder({
        cp_trade_sn: obj,
        appKey: appkey,
        user_id: user_id,
        time_stamp: Date.parse(new Date()) / 1000,
        access_token: access_token,
      });
    } catch (err) {

    }
    let result = 2;
    let msg = '未支付';
    if (r.ret == 1) {
      let content = r.content;
      //支付成功
      if (content > 1) {
        //成功需要关闭定时器
        if (window.cxQueryInterval) clearInterval(window.cxQueryInterval);
        result = 1
        msg = '支付成功';
      }
    }
    const orderCallback = rootState.message.orderCallback;
    if (orderCallback) {
      const params = {
        code: result,
        msg: msg,
      };
      window.frames['gameFrame'].postMessage({ action: orderCallback, params }, '*');
    }

  },
  /**
   * 获取iOS内购商品ID列表
   * @param {*} param0 
   * @param {*} appkey 游戏key
   */
  async fetchInnerProductIdList({ commit, rootState }) {
    // const appkey = 200022123;
    const {
      user: {appkey,  user_id }
    } = rootState;

    const store_type = getStorage('store_type') || 0;
    try {
      const res = await getInnerProductId({ appkey: appkey, user_id: user_id, store_type: store_type });
      if (res.ret === 1 && res.content) {
        // 返回完整的content内容，包含status和inner_product_id_list
        commit('SET_INNER_PRODUCT_ID_LIST', res.content.inner_product_id_list || {});
        return res.content;
      } else {
        commit('SET_INNER_PRODUCT_ID_LIST', {});
        return { status: 0, inner_product_id_list: {} };
      }
    } catch (e) {
      console.log('获取内购商品ID列表失败:', e);
      console.log('错误详情:', {
        message: e.message,
        code: e.code,
        config: e.config,
        response: e.response
      });
      commit('SET_INNER_PRODUCT_ID_LIST', {});
      return { status: 0, inner_product_id_list: {} };
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
